export const environment = {
    production: false,
    baseUrl:'https://dryiotapi-cdt.maersk-digital.net/api/v1/',
    telemetryUrl:'https://drytelemetryapi-cdt.maersk-digital.net/api/v1/',
    inventoryUrl: 'https://inventoryapi-cdt.maersk-digital.net/api/',
    faroEnvironment:'cdt',
    api_key_rum:'4fwnJKTJkPbKx6sF4jm1tOUjzXxZi/h/1gOawR6wvN+bB1o6IGnylgY/jICY7g==',
    azureMapKey: 'e9cIPxHSIZm-9op0cyv22KBdEK0NDzx-AHjyIL9GGR4',
    forgeRockAuthorityUrl: 'https://accounts-cdt.maersk.com/ocean-maeu',
    postLoginRedirectUri: 'https://dryiot-cdt.maersk.com/oauth2/login',
    postLogoutRedirectUri: 'https://dryiot-cdt.maersk.com/oauth2/logout',
    declineRedirectUrl: 'https://www.maersk.com/'
};
